module.exports = __webpack_public_path__ + "img/404.50670598.png";